import React from 'react';
import { localize } from '../../../../locales';
import './index.css';
const LoginFooter = (props) => {
	const icon = require('assets/images/baicon.png');

	const goToPath = (path, type) => {
		const w = window.open('about:blank');
		w.location.href = type === 'yes' ? path : `${window.origin}${path}`;
	};
	return (
		<div className="view-footer-layout">
			<div className="view-footer-words">
				<span className="view-footer-words-hover view-footer-words-margin">
					<a onClick={() => goToPath('/protection', 'no')}>{localize('protection')}</a>
				</span>
				<span className="view-footer-line">|</span>
				<span className="view-footer-words-hover view-footer-words-margin">
					<a onClick={() => goToPath('/imprint', 'no')}>{localize('imprint')}</a>
				</span>
				<span className="view-footer-line">|</span>
				<span className="view-footer-words-hover view-footer-words-margin">
					<a onClick={() => goToPath('/terms', 'no')}>{localize('terms')}</a>
				</span>
			</div>
			<div className="view-footer-copyright">
				ⓒ 2025 汉高（中国）投资有限公司，上海，中国
				<span
					onClick={() => goToPath('https://beian.miit.gov.cn/#/Integrated/index', 'yes')}
					className="view-footer-words-underline view-footer-words-hover "
				>
					沪ICP备10028897号-67
				</span>
				,
				<img className="img" src={icon} alt="" />
				<span
					onClick={() => goToPath('https://beian.mps.gov.cn/#/query/webSearch', 'yes')}
					className="view-footer-words-underline view-footer-words-hover "
				>
					沪公网安备31011002007579号
				</span>
			</div>
		</div>
	);
};
export default LoginFooter;
